import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"no-flash"} maskId="square-filled-radius-0-stroke-1-IconNoFlash"><path d="M16.2772 15.157L22.205 20.4608L21.5382 21.206L1.79297 3.53922L2.45976 2.79398L8.31366 8.03168L14.0004 0.212402V7.99999H21.4823L16.2772 15.157Z" fill="currentColor"/><path d="M2.51852 16L7.13167 9.65691L15.0952 16.7822L10.0004 23.7876V16H2.51852Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNoFlash;
